import axios from './request'

const URL = {
  // login: '/SSO-SERVER/authentication/form',
  getUserKey: '/AUTH-SERVER/user/appKey.magpie',
  login: '/SSO-SERVER/app/encryptToken',
  noEncryptlogin: '/SSO-SERVER/app/token',
  getPermission: '/JURISDICTION-SERVICE-MAGPIE/facade/treeBySystem.magpie',
  getAction: '/JURISDICTION-SERVICE-MAGPIE/facade/getMenuByPid.magpie',
  checkCode: '/USER-SERVER/appuser/checkCode.magpie',
  smsCode: '/USER-SERVER/appuser/smsCode.magpie',
  resetPsw: '/USER-SERVER/appuser/resetPwdWithToken.magpie',
  childAccount: '/ACCOUNT-SERVICE/userAccount/childAccount.magpie', // 查询子账号
}
class User {
  /**
   * 获取userKey和salt  进行加密
   * @param {sting} userName
   * @param {string} marketId
   */
  getUserKey (param) {
    const url = URL.getUserKey
    return axios.post(url, param)
  }
  /**
   * 加密登陆
   * @param {sting} userKey
   * @param {string} password
   */
  login (param) {
    // 先变成不加密
    const url = URL.login
    param.loginType = 'json'
    return axios.post(url, param)
  }

  logout () {

  }
  /**
   * 校验验证码
  */
  checkCode (param) {
    const url = URL.checkCode
    return axios.post(url, param)
  }
  /**
   * 获取验证码
  */
  smsCode (param) {
    const url = URL.smsCode
    return axios.post(url, param)
  }
  /**
   * 忘记密码
  */
  resetPsw (param) {
    const url = URL.resetPsw
    return axios.post(url, param)
  }
  /**
   * 获取菜单权限
  */
  getPermission (systemCode) {
    const url = URL.getPermission
    const param = {}

    return axios.post(url, param, {
      headers: {
        'system-type': systemCode
      }
    })
  }

  getAction (menuId) {
    const url = URL.getAction
    const param = {
      menuId,
    }

    return axios.post(url, param)
  }
  // 查询子账号
  childAccount (param) {
    const url = URL.childAccount

    return axios.post(url, param)
  }
}

export default new User()
